import { render, staticRenderFns } from "./GlossaryResults.vue?vue&type=template&id=01fae8b4&"
import script from "./GlossaryResults.vue?vue&type=script&lang=js&"
export * from "./GlossaryResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fae8b4')) {
      api.createRecord('01fae8b4', component.options)
    } else {
      api.reload('01fae8b4', component.options)
    }
    module.hot.accept("./GlossaryResults.vue?vue&type=template&id=01fae8b4&", function () {
      api.rerender('01fae8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/glossary/GlossaryResults.vue"
export default component.exports